__turbopack_context__.v({
  "algoliaCard": "VCard-module__EfcRxq__algoliaCard",
  "author": "VCard-module__EfcRxq__author",
  "cAuthorName": "VCard-module__EfcRxq__cAuthorName",
  "categoryOther": "VCard-module__EfcRxq__categoryOther",
  "content": "VCard-module__EfcRxq__content",
  "contentCard": "VCard-module__EfcRxq__contentCard",
  "image": "VCard-module__EfcRxq__image",
  "tagLink": "VCard-module__EfcRxq__tagLink",
  "v-card": "VCard-module__EfcRxq__v-card",
});
